import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, type CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { EnvConfigService } from '../../../shared/services/env-config.service';

// Guard for internal routes (requires authentication)
export const InternalGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const env = inject(EnvConfigService);
 
  return authService.currentUser$.pipe(
    map(user => {
      if (user) {
        authService.getPortalPermissions();
        return true;
      } else {
        if (authService.getApiKey()) {
          authService.getPortalPermissions();
          return true;
        }
        if (env.getConfig().isRunAsLibrary) {
          router.navigate(['/dispatch/auth']);
        } else {
          router.navigate(['/auth']);
        }
        return false;
      }
    }),
    catchError(() => {
      if (env.getConfig().isRunAsLibrary) {
        router.navigate(['/dispatch/auth']);
      } else {
        router.navigate(['/auth']);
      }
      return of(false);
    }),
  );
};

//Guard for external pages (public) doesn't need for an authentication
export const ExternalGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const env = inject(EnvConfigService);

  return authService.currentUser$.pipe(
    map(user => {
      if (user) {
        if (env.getConfig().isRunAsLibrary) {
          router.navigate(['/dispatch']);
        } else {
          router.navigate(['/']);
        }
        return false;
      } else {
        if (authService.getApiKey()) {
          return false;
        }
        return true;
      }
    }),
    catchError(() => {
      return of(true);
    }),
  );
};
